<script setup lang="ts">
// Vendor
import type { Entry } from "contentful";

defineProps<{
  content?: Entry[];
  heroContent?: Entry["fields"] | null;
  heroContentType?: string;
}>();
</script>

<template>
  <div class="main-app">
    <div :class="['hero-wrapper', { wrap: heroContentType !== 'hero' }]">
      <ContentfulSection v-if="heroContent" :content="heroContent" />
    </div>

    <div class="wrap mt56 mb56">
      <template v-for="contentEntry in content" :key="contentEntry.sys.id">
        <ContentfulSection
          v-if="contentEntry.sys.contentType.sys.id === 'section'"
          :content="contentEntry"
          :content-type="contentEntry.sys.contentType.sys.id"
        />
        <ContentfulMissingComponent v-else />
      </template>
    </div>
  </div>
</template>
